import React from 'react';
import { Image } from 'react-konva';
import HistogramImage from 'components/main/images/Histogram.png';
const Histogram = (props) => {
  const drawImage = () => {
    const imageObj = new window.Image();
    imageObj.src = HistogramImage;
    const { loc } = props;
    return (
      <Image
        id='histogram-img'
        x={loc.x + props.index * props.iconwidth}
        y={loc.y + loc.h - props.iconheight}
        image={imageObj}
        width={props.iconwidth}
        height={props.iconheight}
      />
    );
  };

  return drawImage();
};
export default Histogram;
